module.exports = __webpack_public_path__ + "static/media/Call_Ringing.9972b4c5.svg";